import { render, staticRenderFns } from "./rank.vue?vue&type=template&id=4b35bb58&scoped=true"
import script from "./rank.vue?vue&type=script&lang=js"
export * from "./rank.vue?vue&type=script&lang=js"
import style0 from "./rank.vue?vue&type=style&index=0&id=4b35bb58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b35bb58",
  null
  
)

export default component.exports